import type { Data } from "app/modules/api-client/queryTypes";
import { ResponseError } from "app/services/fetchService";

type AiAdRecord = Data<"AdIntAiAds", "adintelligenceAiadsGalleryList">["data"][number];
type OverviewRecord = Data<"AiRefferrals", "aiResearchAiTrafficOverviewList">["records"][number];

export const AI_ADS_PLATFORM_ORDER = ["Gpt", "GoogleAiMode", "GoogleAiOverview"] as const;
export type AiAdsPlatform = (typeof AI_ADS_PLATFORM_ORDER)[number];

export type AiAdsDisplay = {
    uniqueAdCount: number;
    platforms: AiAdsPlatform[];
    isTruncated: boolean;
};

export const normalizeDisplayDomain = (domain: string): string => domain.replace(/^www\./i, "").toLowerCase();

export const isAiInsightsUnsupportedQueryError = (error: unknown): boolean => {
    if (!(error instanceof ResponseError)) {
        return false;
    }

    return error.status === 400 || error.status === 404;
};

export const getLeadingAssistantName = (records: OverviewRecord[] | undefined): string | null => {
    const top = records?.[0];
    return top?.name && top.totalVisits > 0 ? top.name : null;
};

export const getAiAdsDisplay = (ads: AiAdRecord[], isTruncated = false): AiAdsDisplay | null => {
    if (ads.length === 0) {
        return null;
    }

    return {
        uniqueAdCount: new Set(ads.map((ad) => ad.creativeId)).size,
        platforms: AI_ADS_PLATFORM_ORDER.filter((platform) => ads.some((ad) => ad.platform === platform)),
        isTruncated,
    };
};
